import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomToast, {atomToastAutoCloseTimes} from '@s-ui/react-atom-toast'
import Context from '@s-ui/react-context'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {NOTIFICATION_TYPES, NOTIFICATION_TYPES_DICTIONARY, NOTIFICATIONS} from './config.js'

const NotificationAi = ({onClose, type}) => {
  const {i18n} = useContext(Context)
  const notificationConfig = NOTIFICATIONS[type]

  const baseClasses = cx('mt-NotificationAi', {
    'mt-NotificationAi--success': type === NOTIFICATION_TYPES.SUCCESS
  })

  return (
    <AtomToast
      autoCloseTime={atomToastAutoCloseTimes.short}
      globalClose
      iconClose={<IconClose size={atomIconSizes.medium} />}
      onClose={onClose}
      show
    >
      <div className={baseClasses}>
        {notificationConfig.icon}
        <p className="mt-NotificationAiText">{i18n.t(notificationConfig.message)}</p>
      </div>
    </AtomToast>
  )
}

export {
  NOTIFICATION_TYPES as iaSearchNotificationTypes,
  NOTIFICATION_TYPES_DICTIONARY as iaSearchNotificationTypesDictionary
}

NotificationAi.displayName = 'NotificationAi'
NotificationAi.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.string
}

export default NotificationAi
